import type { ViewData } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/multisection.data';
import { pushGapToColumn } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/sections.common';
import { MULTI_SECTION_SHELF_TOP_GAP } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/header/common/header.figma';

export function addHeaderGapsShelf(
  height = MULTI_SECTION_SHELF_TOP_GAP
): (viewData: ViewData) => Promise<ViewData> {
  return async (viewData: ViewData): Promise<ViewData> => {
    viewData.layoutTable!.forEach(pushGapToColumn(height, viewData));
    return viewData;
  };
}
